import React from "react";

export default class AboutUs extends React.Component {

	render(){
		return(
			<p> About Us heh</p>
		)
	}
}


// WEBPACK FOOTER //
// ./src/views/AboutUs.js